/**
 * Detect touch gestures on element
 */
export default class SwipeZone {
  /**
   * @param {Node|String} element
   * @param {String} threshold
   */
  constructor(element, threshold) {
    this.xDown = null
    this.yDown = null
    this.width = null
    this.height = null
    this.moveListener = null
    this.isPercentageThreshold = threshold.includes('%')
    this.threshold = parseInt( threshold.replace(/%|px|\s/g, '') ) || 0
    this.element = typeof(element) === 'string' ? document.querySelector(element) : element

    this.element.addEventListener('touchstart', e => {
      this.xDown = e.touches[0].clientX
      this.yDown = e.touches[0].clientY
    })

    this._updateDimensions()
    window.addEventListener('resize', () => this._updateDimensions())

    this.enable()
  }

  _handleTouchMove(e) {
    if ( !this.xDown || !this.yDown ) return
    const xUp = e.touches[0].clientX
    const yUp = e.touches[0].clientY

    this.xDiff = this.xDown - xUp
    this.yDiff = this.yDown - yUp

    if ( Math.abs(this.xDiff) > Math.abs(this.yDiff) ) {
      // Swiping horizontally
      const threshold = this.isPercentageThreshold ? this.width * this.threshold * 0.01 : this.threshold
      if (this.xDiff > threshold) this._fire('left')
      else if (this.xDiff < -threshold) this._fire('right')

      e.preventDefault()

    } else {
      // Swiping vertically
      const threshold = this.isPercentageThreshold ? this.height * this.threshold * 0.01 : this.threshold
      if (this.yDiff > threshold) this._fire('up')
      else if (this.yDiff < -threshold) this._fire('down')
    }
  }

  _updateDimensions() {
    const rect = this.element.getBoundingClientRect()
    this.width = rect.width
    this.height = rect.height
  }

  _fire(direction) {
    direction === 'left' ? this.onLeft()
    : direction === 'right' ? this.onRight()
    : direction === 'up' ? this.onUp()
    : this.onDown()

    this.xDown = null
    this.yDown = null
  }

  onLeft(callback) {
    if (callback) this.onLeft = callback
    return this
  }

  onRight(callback) {
    if (callback) this.onRight = callback
    return this
  }

  onUp(callback) {
    if (callback) this.onUp = callback
    return this
  }

  onDown(callback) {
    if (callback) this.onDown = callback
    return this
  }

  enable() {
    if (!this.moveListener) {
      this.element.addEventListener('touchmove', this.moveListener = e => {
        this._handleTouchMove(e)
      })
    }

    return this
  }

  disable() {
    if (this.moveListener) {
      this.element.removeEventListener('touchmove', this.moveListener)
      this.moveListener = null
    }

    return this
  }
}
